
import { NotificationManager } from 'react-notifications';
import apiRequestService from '../component/ApiRequestService';
import { AppSetting } from '../common/function';


export default class UserAccessDetails{
    AppSetting = AppSetting()

    constructor(){
        this.userAccessDetails = {};
    }

    fetch(){
        let storedUserDetails = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`);
        if(storedUserDetails){
            this.userAccessDetails =JSON.parse(storedUserDetails);
        }else{
            this.userAccessDetails = null
        }

         
    }

    save(){
        if (this.userAccessDetails.subjects == undefined) {
            this.fetch()
        }  
        window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`,JSON.stringify(this.userAccessDetails) );
    }
    addSubject(subject_id){
        this.userAccessDetails.subjectsbyInstructor[subject_id] = true;
        this.save();
    }
    removeSubject(subject_id){
        delete this.userAccessDetails.subjectsbyInstructor[subject_id]
        this.save();
    }

    getAllSubjects(archive_mode){
        return new Promise((resolve, reject) => {
            /*if(this.userAccessDetails && this.userAccessDetails.subjects && archive_mode !== true)          {
                resolve(this.userAccessDetails.subjects);
            }else{*/
                let payload = {};
                if(archive_mode){
                    payload = {
                        "archive_id":1,
                        "archive_mode":true
                    }
                }
                apiRequestService({
                    method: 'post',
                    url: '/getAllSubjects',
                    data:payload
                }).then(res => {
                    if (res.data.message !== null && res.data.message !== '') {
                        reject(res.data.message);
                    }
                else{
                    let subjects =res.data.data.subject_names; 
                    this.userAccessDetails.subjects = subjects;
                    this.save();
                    resolve(subjects);                     
                }
                }).catch(err =>{
                    reject(err);
                });
           // }
        });
    }

    getSubjectsByInstructor(){
        let instructorName = window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`);
        const payload = {
            instructor_name: instructorName
        }
        return new Promise((resolve, reject) => {
            /*if(this.userAccessDetails && this.userAccessDetails.subjectsbyInstructor)          {
                resolve(this.userAccessDetails.subjectsbyInstructor);
            }else{*/
                apiRequestService({
                    method: 'post',
                    url: '/getAllInstSubjects',
                    data: payload
                }).then(res => {
                    if (res.data.message !== null && res.data.message !== '') {
                        NotificationManager.error(res.data.message, 'ERROR', 3000);
                        reject(res.data.message);
                    }
                else{
                    let subjects =res.data.data.subject_id; 
                    this.userAccessDetails.subjectsbyInstructor = subjects;
                    this.save();
                    resolve(subjects);                     
                }
                }).catch(err =>{
                    reject(err);
                });
            //}
        });
    }

}